import { useCallback } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type LockScreenServiceResponse = {
	predunning: boolean;
	predunningDaysLeft: number;
	isBillingAdmin: boolean;
	isBillingUser: boolean;
	transactionAccountId?: string;
	invoiceGroupId?: string;
	usageOverLimit?: boolean;
};

const fetchLockScreenDetails = async (entitlementId?: string) => {
	if (!entitlementId) throw new Error('empty entitlementId');

	return performGetRequest<LockScreenServiceResponse>(
		`/gateway/api/growth/trial-end-lock-screen/is-locked?entitlementId=${entitlementId}`,
		{
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
};

export const useLockScreenService = ({
	entitlementId,
	onError,
}: {
	entitlementId?: string;
	onError: (err: Error) => void;
}) => {
	const request = useCallback(async () => {
		try {
			const result = await fetchLockScreenDetails(entitlementId);
			return result;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			onError(err);
			throw err;
		}
	}, [entitlementId, onError]);

	return useService(request);
};
